/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Fragment } from 'react';
import {
  connectHits,
  connectStateResults,
  connectStats
} from 'react-instantsearch-dom';

function getInsightsFields(searchResults = {}, hit = {}) {
  const { index, queryID }: { index?: number; queryID?: string } =
    searchResults;
  const {
    __position: position,
    objectID
  }: { __position?: number; objectID?: string } = hit;

  return {
    index,
    queryID,
    ...(objectID ? { objectIDs: [objectID] } : {}),
    ...(position ? { positions: [position] } : {})
  };
}

interface SearchPanelHitsProps {
  hitComponent: any;
  hitProps: any;
  hits: any;
  nbHits: number;
  notFoundComponent?: any;
  searchResults: any;
}

const CustomHits = connectStats(
  connectHits(
    connectStateResults(
      ({
        searchResults,
        nbHits,
        hits,
        hitComponent: HitComponent,
        notFoundComponent: NotFoundComponent,
        hitProps = {}
      }: SearchPanelHitsProps) => {
        const { showNbResults = false, showTitle, title } = hitProps;

        return !searchResults ? (
          <></>
        ) : nbHits === undefined || nbHits === 0 ? (
          NotFoundComponent ? (
            <NotFoundComponent />
          ) : (
            <Fragment />
          )
        ) : (
          <>
            {showTitle && title && (
              <span className="mb-4 flex items-baseline gap-[6px] font-heading text-[16px] font-medium leading-5">
                <span>{title}</span>
                <span className="text-label">{nbHits} results</span>
              </span>
            )}
            {showNbResults && (
              <span className="text-label">{nbHits} results</span>
            )}
            <>
              {hits.slice(0).map((hit: any, index: number) => (
                <HitComponent
                  {...hit}
                  hit={hit}
                  key={hit.objectID}
                  position={index + 1}
                  insightsFields={getInsightsFields(searchResults, hit)}
                  {...hitProps}
                />
              ))}
            </>
          </>
        );
      }
    )
  )
);

export default CustomHits;
